export class FormItem {
	isValidSerialNumber: boolean;
	isValidCellCode: boolean;
	inputValue: string;
	errorMessage: string;
	cellErrorMessage: string;
}
